import React from 'react';
const defaultState  = {
    name:"test name", address:{
        street:"Street no 34",
        area:"khajaguda",
        pincode:500042
      }
}
const MyContext = React.createContext(defaultState);

export default MyContext;